import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { formatNumber } from '@angular/common';
import { CampaignCrmClientStatisticsFilter, CampaignCrmClientStatisticsModel } from 'src/app/models/renault-campaign-crm-client-dto';
import { CampaignCrmClientService } from 'src/app/services/campaign-crm-client.service';
import Swal from 'sweetalert2';
import * as Highcharts from 'highcharts';
import funnel from 'highcharts/modules/funnel';
import { ThisReceiver } from '@angular/compiler';
funnel(Highcharts);



@Component({
  selector: 'campaign-crm-statistics',
  templateUrl: './campaign-crm-statistics.component.html',
  styleUrls: ['./campaign-crm-statistics.component.scss']
})
export class CampaignCrmStatisticsComponent implements OnInit {



  @Input() filter: string;
  @Input() data: string;
  @Input() id: string;
  hasData = false;
  loaded = false;


  model: CampaignCrmClientStatisticsModel;
  public optionFunnelChart: any = {
    chart: {
      type: 'funnel',
      backgroundColor: 'transparent',
      height: '460'
    },
    tooltip: {
      pointFormat: '{point.title} {point.y:,.0f}'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderColor: '#F1F1F2',
        borderWidth: 8,
        dataLabels: {
          format: '{point.title} {point.y:,.0f}  {point.i} <br><br>'
        },
        center: ['40%', '45%'],
        width: '80%'
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: '',
      data: []
    }]
  };
  public optionDonutChart: any = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      height: '300'
    },
    title: {
      text: '',
      align: 'center',
      verticalAlign: 'middle',
      y: -10,
      x: 10,
      style: {
        fontWeight: 'bold'
      },
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderColor: '#F1F1F2',
        borderWidth: 0,
        dataLabels: {
        },
        center: ['50%', '45%'],
        width: '100%'
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: '',
      size: '100%',
      innerSize: '50%',
      showInLegend: false,
      dataLabels: {
        enabled: false
      },
      data: []
    }],
  };

  constructor(private service: CampaignCrmClientService) {
  }

  ngOnInit(): void {
    // if (this.data === undefined)
    //   this.getDataAnual();
    // else {
    //   this.model = JSON.parse(this.data);
    //   this.setCharts();
    // }

  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes["filter"]) {
      this.getDataAnual();
    }
    else if (changes["data"]) {
      this.model = JSON.parse(this.data);
      this.hasData = this.checkHasData();
      this.loaded = true;
      this.setCharts();
    }
  }

  getDataAnual() {
    this.service.GetCampaignCrmClientStatisticsAnual(JSON.parse(this.filter)).subscribe(res => {
      this.model = res;
      this.hasData = this.checkHasData();
      this.loaded = true;
      this.setCharts();
    });
  }



  setCharts() {
    Highcharts.setOptions({
      colors: ['#000000', '#66D8D0', '#FFBD69', '#4B9BF5', '#d8c4a0', '#CB4B32', '#60504a', '#66d8d0', '#244f35'],
      lang: {
        decimalPoint: ',',
        thousandsSep: '.'
      }
    });

    let openPercent = " (" + Math.round(this.model.Success > 0 ? this.model.Open * 100 / this.model.Success : 0) + "%)";
    let clicsPercent = " (" + Math.round(this.model.Open > 0 ? this.model.Click * 100 / this.model.Open : 0) + "%)";
    let exitoPercent = " (" + Math.round(this.model.ContactEmail > 0 ? this.model.Success * 100 / this.model.ContactEmail : 0) + "%)";
    let reimpactPercent = " (" + Math.round(this.model.Contact > 0 ? this.model.Reimpact * 100 / this.model.Contact : 0) + "%)";
    let resentMailPercent = " (" + Math.round(this.model.Contact > 0 ? this.model.Email * 100 / this.model.Contact : 0) + "%)";
    let visitPercent = " (" + Math.round(this.model.Success > 0 ? this.model.Visit * 100 / this.model.Success : 0) + "%)";

    this.optionFunnelChart.series[0].data = [
      { title: '<div class="funnel-chart-data-title">Impactos Marca</div>', y: this.model.Contact },
      { title: '<div class="funnel-chart-data-title">Impactos emails</div>', y: this.model.ContactEmail },
      { title: '<div class="funnel-chart-data-title">Éxito</div>', y: this.model.Success, i: exitoPercent },
      { title: '<div class="funnel-chart-data-subtitle">Abiertos</div>', y: this.model.Open, i: openPercent },
      { title: '<div class="funnel-chart-data-subtitle">Clics</div>', y: this.model.Click, i: clicsPercent },
      // { title: '<div class="funnel-chart-data-title">Impactos Marca</div><div class="funnel-chart-data">'+this.model.Contact+'</div><div class="funnel-chart-subdata">Abiertos '+this.model.Open+'</div><div class="funnel-chart-subdata">Clics '+this.model.Click+'</div>',  y: this.model.Visit },

      // Muestra emails y llamadas
      //{ title: '<div class="funnel-chart-data-title">Reimpacto Puntos de Red</div>', y: this.model.Reimpact, title2: '<div class="funnel-chart-data-subtitle">Llamadas</div>', y2: this.model.Call, title3: '<div class="funnel-chart-data-subtitle">Emails</div>', y3: this.model.Email },

      { title: '<div class="funnel-chart-data-title">Reimpacto Puntos de Red</div>', y: this.model.Reimpact, i: reimpactPercent },
      { title: '<div class="funnel-chart-data-title">Email Puntos de Red</div>', y: this.model.Email, i: resentMailPercent },
      { title: '<div class="funnel-chart-data-title">Visitas taller</div>', y: this.model.Visit, i: visitPercent }

    ];
    this.optionDonutChart.title.text = '<div class="donut-chart-data" y="135">' + formatNumber(this.model.Call + this.model.Pending, 'es') + '</div><div class="donut-chart-data-title" y="140"> <tspan x="0" dy="12">Contactos</tspan><tspan x="0" dy="12">Potenciales</tspan></div>'
    this.optionDonutChart.title.y = 30;
    this.optionDonutChart.title.x = 0;
    this.optionDonutChart.series[0].data = [
      { name: 'Llamadas', y: this.model.Call },
      { name: "Pendientes", y: this.model.Pending }

    ];
    setTimeout(() => {
      Highcharts.chart('chartFunnel' + this.id, this.optionFunnelChart);
      Highcharts.setOptions({
        colors: ['#AEEAE6', '#CB4B32', '#FFBD69', '#4B9BF5', '#d8c4a0', '#CB4B32', '#60504a', '#66d8d0', '#244f35']
      });
      Highcharts.chart('chartDonut' + this.id, this.optionDonutChart);
    }, 500);


  }


  checkHasData() {
    if (this.model.Call == 0
      && this.model.Click == 0
      && this.model.Contact == 0
      && this.model.Email == 0
      && this.model.Open == 0
      && this.model.Pending == 0
      && this.model.Reimpact == 0
      && this.model.Visit == 0
    ) return false;

    else return true;
  }
}
